import React from 'react';
import { FadeIn } from './FadeIn';
import { Lock, ShieldCheck, Zap } from 'lucide-react';
export function PricingCTA() {
  return <section id="pricing" className="py-24 px-4 bg-brand-dark relative overflow-hidden" data-id="element-118">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[500px] bg-brand-orange/10 blur-[120px] rounded-full pointer-events-none" data-id="element-119" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-120">
        <FadeIn data-id="element-121">
          <div className="text-center mb-12" data-id="element-122">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-white uppercase mb-6" data-id="element-123">
              Tu tranquilidad no debería costar una fortuna
            </h2>
            <p className="text-xl text-gray-400" data-id="element-124">
              Accede al Protocolo 72 Horas completo hoy mismo.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-125">
          <div className="bg-brand-gray border-2 border-brand-orange rounded-2xl p-8 md:p-12 shadow-[0_0_50px_rgba(255,102,0,0.15)] max-w-2xl mx-auto text-center relative" data-id="element-126">
            {/* Badge */}
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-brand-orange text-white px-6 py-2 rounded-full font-bold uppercase tracking-wider text-sm flex items-center gap-2 shadow-lg" data-id="element-127">
              <Zap size={16} data-id="element-128" />
              Precio Especial de Lanzamiento
            </div>

            <div className="mt-8 mb-10" data-id="element-129">
              <span className="text-7xl font-display font-bold text-white" data-id="element-130">
                $27.00
              </span>
              <span className="text-2xl text-gray-400 font-bold ml-2" data-id="element-131">USD</span>
            </div>

            <a href="https://omnilectura.com/cart/48145287315681:1" target="_blank" rel="noopener noreferrer" onClick={() => {
            if (window.fbq) {
              window.fbq('track', 'AddToCart', {
                content_name: 'Protocolo 72 Horas',
                content_type: 'product',
                value: 27.0,
                currency: 'USD'
              });
              window.fbq('track', 'Purchase', {
                content_name: 'Protocolo 72 Horas',
                content_type: 'product',
                value: 27.0,
                currency: 'USD'
              });
            }
          }} className="group relative w-full inline-flex items-center justify-center px-8 py-6 font-bold text-white text-xl uppercase tracking-widest bg-brand-orange overflow-hidden transition-all hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-brand-orange focus:ring-offset-2 focus:ring-offset-brand-dark rounded-lg shadow-[0_0_20px_rgba(255,102,0,0.4)] hover:shadow-[0_0_30px_rgba(255,102,0,0.6)] hover:-translate-y-1" data-id="element-132">
              <span className="absolute w-0 h-0 transition-all duration-500 ease-out bg-white rounded-full group-hover:w-[150%] group-hover:h-56 opacity-10" data-id="element-133"></span>
              <span className="relative flex items-center gap-3" data-id="element-134">
                ¡SÍ, QUIERO PROTEGER A MI FAMILIA AHORA!
                <svg className="w-6 h-6 transition-transform group-hover:translate-x-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-135">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-136"></path>
                </svg>
              </span>
            </a>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-6 text-gray-400 text-sm" data-id="element-137">
              <div className="flex items-center gap-2" data-id="element-138">
                <Lock className="w-4 h-4 text-green-500" data-id="element-139" />
                Compra 100% segura
              </div>
              <div className="hidden sm:block w-1 h-1 bg-gray-600 rounded-full" data-id="element-140" />
              <div className="flex items-center gap-2" data-id="element-141">
                <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-142" />
                Acceso inmediato a la descarga
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}